// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__25TYC","balanceDisclaimer":"posDashboard_balanceDisclaimer__1t5sz"};